import { render, staticRenderFns } from "./staffRepairPage.vue?vue&type=template&id=8b6a31e6&scoped=true"
import script from "./staffRepairPage.vue?vue&type=script&lang=js"
export * from "./staffRepairPage.vue?vue&type=script&lang=js"
import style0 from "./staffRepairPage.vue?vue&type=style&index=0&id=8b6a31e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b6a31e6",
  null
  
)

export default component.exports